import { render, staticRenderFns } from "./detailDetail.vue?vue&type=template&id=7c017ac6&scoped=true&"
import script from "./detailDetail.vue?vue&type=script&lang=js&"
export * from "./detailDetail.vue?vue&type=script&lang=js&"
import style0 from "./detailDetail.vue?vue&type=style&index=0&id=7c017ac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c017ac6",
  null
  
)

export default component.exports